import { Favourite } from '../../ProductList/Favourite';
import { Above, Below } from '@jetshop/ui/Breakpoints';
// import Gallery from '@jetshop/ui/Gallery/Gallery';
import Badges from '@jetshop/ui/ProductList/Badges';
import React from 'react';
import { styled } from 'linaria/react';
import { useSwitchToVariantImage } from '@jetshop/core/hooks/Product';

import { theme } from '../../Theme';
import { Gallery } from './Gallery';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  position: relative;

  &.images-1 {
    .image-gallery-slide-wrapper {
      width: 100%;
    }
  }

  .image-gallery-slide-wrapper {
    position: relative;
    ${theme.below.lg} {
      width: 100%;
      &:before {
        display: none;
      }
    }
    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.025);
      pointer-events: none;
      z-index: 1;
    }
  }
  .image-gallery-thumbnails {
    justify-content: flex-start !important;
  }
  .image-gallery-thumbnails-wrapper {
    margin: 0;
    ${theme.below.lg} {
      display: none;
    }
  }
  .image-gallery-thumbnails-container {
  }
  .image-gallery-thumbnail {
    position: relative;
    border: 1px solid white !important;
    margin-bottom: 7px;
    &.active {
      border: 1px solid black !important;
    }
    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.025);
      pointer-events: none;
      z-index: 1;
    }
  }

  .image-gallery-slide {
    ${theme.below.lg} {
      width: 80%;
      margin: auto;
      left: 0;
      right: 0;
      padding: 3px;
      .image-gallery-image {
        position: relative;
        &:before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.025);
          pointer-events: none;
          z-index: 1;
        }
      }
    }
  }
`;

export default function ImageContainer({
  images,
  badges,
  variant,
  product,
  video,
  ...rest
}) {
  const galleryRef = React.createRef();
  // Enable switching gallery to image of selected variant
  useSwitchToVariantImage({
    galleryImages: images,
    galleryRef,
    variant
  });

  return (
    <Wrapper {...rest} className={'images-' + images.length}>
      <Favourite
        product={product}
        style={{
          position: 'absolute',
          padding: '0.5em',
          fontSize: '1.5em',
          top: 0,
          right: '0.5em',
          zIndex: '2'
        }}
      />
      <Below breakpoint="md">
        <Badges badges={badges} />
      </Below>
      <Gallery
        aspect={'825:1000'}
        images={images}
        galleryRef={galleryRef}
        video={video}
        thumbnailPosition="left"
      >
        <Above breakpoint="md">
          <Badges badges={badges} />
        </Above>
      </Gallery>
    </Wrapper>
  );
}
